import * as Yup from "yup";


export const loginvalidationSchema = () =>
    Yup.object({
      email: Yup.string()
        .trim()
        .email("Email is required")
        .required("Email is required")
        .matches(
          /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(\.[a-zA-Z]{2,})?$/,
          "Valid email address"
        ),
    });
  
export const addUser = () => Yup.object().shape({
      Name: Yup.string().required("Please provide the Name"),
      Email: Yup.string().required("Please provide the email"),
      // Company: Yup.string().required(t("viewDocument.Schema.supplierCompany"))
  });

  export const addClient = () => Yup.object().shape({
    ClientName: Yup.string().required("Please provide the Name"),
    Email: Yup.string().required("Please provide the email")
});

export const addProject = () => Yup.object().shape({
  Name: Yup.string().required("Please provide the project name"),
  ClientId: Yup.string().required("Please choose the client")
});
  